import React from "react";
import { useSidebarState } from "react-admin";
import { Button } from "@mui/material";
import { Menu } from "@mui/icons-material";

const MyAppBar = (props) => {
    const [open, setOpen] = useSidebarState(true);
    return (
        <div
         onClick={() => setOpen(!open)}
            style={{
                position:'sticky',
                // padding: "10px",
                backgroundColor: "#f5f5f5",
                display: 'flex',
                justifyContent: 'space-between'
            }}
            className="d-md-none"
        >
            {/* <Button sx={{ background: "#eee" }}>
                <Menu />
            </Button>
            <img style={{ width: "50px" }} src="/images/black-logo.png" /> */}
        </div>
    );
};
export default MyAppBar;
